import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { hyphenateSync as hyphenateEstonian } from "hyphen/et";
import { hyphenateSync as hyphenateLatvian } from "hyphen/lv";
import { hyphenateSync as hyphenateLithuanian } from "hyphen/lt";

const MIN_HYPHENATED_WORD_LENGTH = 12;

const HYPHENATORS_MISSING_IN_BROWSERS = {
  et: hyphenateEstonian,
  lv: hyphenateLatvian,
  lt: hyphenateLithuanian,
};

export const useHyphenate = () => {
  const { i18n } = useTranslation();
  const hyphenator = HYPHENATORS_MISSING_IN_BROWSERS[i18n.language];

  return useCallback(
    (text) =>
      hyphenator && typeof text === "string"
        ? hyphenator(text, { minWordLength: MIN_HYPHENATED_WORD_LENGTH })
        : text,
    [hyphenator]
  );
};
